namespace $ {
	export let $mol_mem_persist = $mol_wire_solid
}
